import { toLabeledValues } from 'components/CIMSSelect/utils/labeledValues'
import { ProjectMetadata } from '../../../../../ProjectSettingsContext/types'
import { EditSettingsModalValues } from '../types'
import { useCallback } from 'react'
import { useUserDeleted } from 'hooks/useUserDeleted'

export function useGetInitialValues({
  admins,
  cmProjectLayersId,
}: Pick<ProjectMetadata, 'cmProjectLayersId' | 'admins'>) {
  const deleted = useUserDeleted()
  return useCallback<() => EditSettingsModalValues>(
    () => ({
      cmProjectLayersId,
      projectAdmins: toLabeledValues(admins, {
        type: 'callback',
        callback: ({ user }) => ({
          value: user.id,
          label: user.username,
          tooltip: user.mail === user.username ? undefined : user.mail,
          deleted: deleted(user),
        }),
      }),
    }),
    [admins, cmProjectLayersId, deleted]
  )
}
